import React from 'react';
import {Formik, Field, Form} from 'formik';
import {TextField, Loading, TextArea,GalleryField,CkEditor} from 'components/form';
import {required, validationWrapper, number, minLength, maxLength, email} from 'lib/formValidations';
import {transformTranslateFromValues, transformTranslateServerValues} from 'lib/helpers';
import Modal from 'components/Modal'
import {useCore} from 'store/core'
import {MultiSelect} from "components/form"
// components

export default function Edit(props) {

   const core = useCore();
   const {show, item} = props

   return (
      <>
         <Modal show={props.show} handleClose={props.close} title={props.title}>
            <Formik
               initialValues={{...transformTranslateServerValues(item)}}
               onSubmit={async (values, {setSubmitting}) => {
                  await props.submit(transformTranslateFromValues(values), item.id);
                  props.close();
                  setSubmitting(false);
               }}
               enableReinitialize
            >

               {({isSubmitting, dirty}) => (
                  <Form>
                     <div className="modal-body py-1 gap-y-3">
                        <div className="intro-x md:grid md:grid-cols-2 md:gap-3">
                           <Field
                              placeholder="نام"
                              label="نام :"
                              name="full_name"
                              component={TextField}
                              validate={(value) => validationWrapper(value, required)}
                           />
                           <Field
                              placeholder="name"
                              label="نام انگلیسی :"
                              name="_en*full_name*text"
                              component={TextField}
                           />
                           {core.activityFieldsLoad ? <Loading/> :
                              <Field
                                 label="زمینه های فعالیت :"
                                 name="activity_fields"
                                 component={MultiSelect}
                                 options={core.activityFields || []}
                              />
                           }
                           <Field
                              label="شماره تماس :"
                              name="tel"
                              component={TextField}
                              validate={(value) => validationWrapper(value, number, minLength(11), maxLength(11))}
                           />
                           <Field
                              label="آدرس ایمیل :"
                              name="email"
                              component={TextField}
                              validate={(value) => validationWrapper(value, email)}
                           />
                           <Field
                              label="محل تولد:"
                              name="birthday_place"
                              component={TextField}
                            
                           />
                           <Field
                              label="تاریخ تولد :"
                              name="birthday"
                              component={TextField}
                            
                           />
                            <Field
                              label="محل تولد(en):"
                              name="_en*birthday_place*text"
                              component={TextField}
                            
                           />
                           <Field
                              label="تاریخ تولد(en) :"
                              name="_en*birthday*text"
                              component={TextField}
                              
                           />
                         
                           <Field
                              label="بیوگرافی"
                              name="biography"
                              component={CkEditor}
                           />
                           <Field
                              label="biography"
                              name="_en*biography*text"
                              component={CkEditor}
                           />
                             <Field
                              label="توضیحات"
                              name="desc"
                              component={CkEditor}
                           />
                           <Field
                              label="description"
                              name="_en*desc*text"
                              component={CkEditor}
                           />
                           <Field
                                    label="تصویر زمینه"
                                    name="background_media_id"
                                    dataType="id"
                                    component={GalleryField}
                                    />
                            <Field
                              label="آواتار"
                              name="avatar_media_id"
                              dataType="id"
                              component={GalleryField}
                              />
                        </div>
                     </div>

                     <div className="modal-footer text-right">
                        <button className="btn btn-primary w-20" type="submit"
                                disabled={!!(isSubmitting || !dirty)}> {isSubmitting ?
                           <Loading/> : 'ذخیره'}</button>
                        <button type="button"
                                disabled={isSubmitting}
                                onClick={props.close} className="btn btn-outline-secondary w-20 mr-1">انصراف
                        </button>
                     </div>
                  </Form>
               )}
            </Formik>
         </Modal>
      </>
   );
}
